import { render, staticRenderFns } from "./bkmvAddFamilyModal.vue?vue&type=template&id=304c0d90&scoped=true"
import script from "./bkmvAddFamilyModal.vue?vue&type=script&lang=js"
export * from "./bkmvAddFamilyModal.vue?vue&type=script&lang=js"
import style0 from "./bkmvAddFamilyModal.vue?vue&type=style&index=0&id=304c0d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304c0d90",
  null
  
)

export default component.exports